import React from 'react'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { Button } from "flowbite-react";
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow } from "flowbite-react";
import { PencilSquareIcon, ArrowUpTrayIcon, ListBulletIcon, TrashIcon } from '@heroicons/react/24/outline'
import Modals from '../../components/Modal'
import FormPermission from './FormPermission';
import LoadingSpinner from '../../components/LoadingSpinner';

const Permission = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);
    const [modalTitle, setModalTitle] = useState("");
    const [permissionId, setPermissionId] = useState(null);
    const [permissions, setPermissions] = useState([]);
    const [error, setError] = useState(null);
    const [isCreating, setIsCreating] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    
    const openModal = (title,permissionId,editMode) => {
        setModalTitle(title);
        setIsModalOpen(true);
        setPermissionId(permissionId);
        setIsCreating(editMode);
    };
    const handleFormSubmit = async(data) => {
        
        let name = data.name == "";
        if(name){ alert("Ingrese el permiso"); return;}

        let slug = data.slug == "";
        if(slug){ alert("Ingrese el codigo"); return;}

        let status = data.status == "";
        if(status){ alert("Seleccione el estado"); return;}
        setIsLoading(true);

        try {
            const response = await axios.post(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/permission/create`,
                data,
                {
                    withCredentials: true,
                }
            );
            setPermissions([...permissions, response.data.new_permission]);
        } catch (error) {
            
        } finally{
            setIsLoading(false);
        }

        closeModal(); 
    };

    const handleFormUpdate = async(data) => {
        setIsLoading(true);
        try {
            const response2 = await axios.put(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/permission/${permissionId}/update`,
                data,
                {
                    withCredentials: true,
                }
            );

            console.log("permissionId",permissionId);
            setPermissions(
                permissions.map((permission) =>
                    permission.id === permissionId ? { ...permissions, ...response2.data.permiso } : permission
                )
            ); 
        } catch (error) {
            
        } finally{
            setIsLoading(false);
        }

        closeModal(); 
    }

    const handleRemove = async (id) => {
        const confirma = confirm('confirma la eliminación del permiso?');
        if (!confirma) return;
        
        setIsLoading(true);
        try{
            const response = await axios.delete(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/permission/${id}/delete`,
                {
                    withCredentials: true,
                }
            );
            if (response.statusText !== "OK") {
                throw new Error(response.message || 'Error en la obtención de datos');
            }
            setPermissions(permissions.filter((permission) => permission.id !== id));
            setToastShow(true)

        }catch(error){
            
        } finally{
            setIsLoading(false);
        }
    }

    useEffect(()=>{
        const getPermissions = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get( 
                    `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/permissions`,
                    {
                        withCredentials: true,
                    }
                );

                if (response.statusText !== "OK") {
                    throw new Error(response.message || 'Error en la obtención de datos');
                }

                setPermissions(response.data);
            } catch (error) {
                setError(error.message);
            }finally{
                setIsLoading(false);
            }
        }
        
        getPermissions();

    },[]);

    return (
        <>
            {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
            <div className="p-2 mt-4 flex justify-between">
                <h1 className="text-xl mb-2 px-3 flex-col">Permisos</h1>
                <div className="flex justify-end">
                    <Button className="text-gray-600" onClick={()=>openModal("Permisos",null,true)} color='gray'>Crear</Button>
                </div>
                {error && <div className="text-red-500">{error}</div>}
            </div>
            <div className="overflow-x-auto text-left">
                <Table>
                    <TableHead>
                        <TableHeadCell className="text-left">Permiso</TableHeadCell>
                        <TableHeadCell className="text-left">Descripción</TableHeadCell>
                        <TableHeadCell className="text-left">Slug</TableHeadCell>
                        <TableHeadCell className="text-left">Estado</TableHeadCell>
                        <TableHeadCell>
                            <span className="srOnly">Acción</span>
                        </TableHeadCell>
                    </TableHead>
                    <TableBody className="divide-y">
                        {permissions.map((permission) => (
                            <TableRow key={permission.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                <TableCell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                    {permission.name}
                                </TableCell>
                                <TableCell>{permission.description}</TableCell>
                                <TableCell>{permission.slug}</TableCell>
                                <TableCell>{(parseInt(permission.status)===1)?'Activo':'Inactivo'}</TableCell>
                                <TableCell className="inline-flex">
                                    <a href="#" onClick={()=>openModal("Permisos",permission.id, false)}>
                                        <PencilSquareIcon className="w-5 text-blue-500 mr-3" title="Editar permiso"/>
                                    </a>
                                    <a href="#" onClick={()=>handleRemove(permission.id)}>
                                        <TrashIcon className="w-5 text-blue-500 mr-3" title="Eliminar permiso"/>
                                    </a>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>

            <Modals isOpen={isModalOpen} onClose={closeModal} title={modalTitle} modalSize={"md"}>
                <FormPermission onSubmit={isCreating ? handleFormSubmit : handleFormUpdate} onClose={closeModal} permissionId={permissionId} />
            </Modals>
        </>
  )
}

export default Permission
